import React from 'react';
import ReactEcharts from 'echarts-for-react';
import PropTypes from 'prop-types';

function GraphGroupsPerHourPercentValues (props) {
  const { members, typeDisplay } = props.el;
  let reports = [];
  const rpts = props.reports.slice();

  if (typeDisplay && typeDisplay !== 'ALL' && members) {
    reports = rpts.filter(rpt => members.includes(rpt._id));
  } else {
    reports = [...rpts];
  }

  const groups = reports.reduce((result, group) => {
    const { name, number, hour, received, pctAnswered, pctLost } = group;
    if (Object.keys(result).includes(number)) {
      result[number].labels = result[number].labels.concat([
        `${hour}\nRCB: ${received}`
      ]);
      result[number].series.pctAnswered = result[
        number
      ].series.pctAnswered.concat([pctAnswered]);
      result[number].series.pctLost = result[number].series.pctLost.concat([
        pctLost
      ]);
    } else {
      result[number] = {};
      result[number].title = `${number} - ${name}`;
      result[number].labels = [`${hour}\nRCB: ${received}`];
      result[number].series = {
        pctAnswered: [pctAnswered],
        pctLost: [pctLost]
      };
    }
    return result;
  }, {});

  return (
    <div>
      {Object.keys(groups).map((number, i) => {
        const type = 'bar';

        const label = {
          normal: {
            show: true,
            position: 'insideBottom',
            fontSize: 16,
            color: '#000',
            verticalAlign: 'center',
            rotate: 90,
            distance: 30,
            fontWeight: 'bold'
          }
        };

        const configs = {
          title: {
            text: groups[number].title,
            left: 'center',
            textStyle: {
              fontSize: 24,
              fontWeight: 'bold'
            }
          },
          grid: { left: '7%', right: '7%', bottom: '23%' },
          animationDuration: 0,
          hoverAnimation: false,
          cursor: 'default',
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          legend: { top: '12%' },
          xAxis: {
            data: [...groups[number].labels],
            axisLabel: {
              fontSize: 24,
              fontWeight: 'bold'
            }
          },
          yAxis: {
            axisLabel: {
              fontSize: 24,
              fontWeight: 'bold'
            }
          },
          series: [
            {
              name: '%ATD',
              type,
              label,
              color: '#16df23',
              legendHoverLink: false,
              data: [...groups[number].series.pctAnswered]
            },
            {
              name: '%PERD',
              type,
              label,
              color: '#da1616',
              data: [...groups[number].series.pctLost]
            }
          ]
        };
        return <ReactEcharts key={i} option={configs} />;
      })}
    </div>
  );
}

export default GraphGroupsPerHourPercentValues;

GraphGroupsPerHourPercentValues.propTypes = {
  el: PropTypes.object,
  reports: PropTypes.array
};
